import React from 'react';
import NotFound from '@/pages/not-found';
import NoPower from '@/pages/no-power';
import ResourcesApply from '@/pages/resources-apply';
import OperatePlatform from '@/pages/operate-platform';
import materialManageRouteConfig from '@/pages/material-manage/route-config';

// 素材管理
import resManageRouteConfig from '@/pages/res-manage/route-config';
import Pkgs from './pkgs';
import pkgsRouteConfig from './pkgs/route-config';
// 趋势运营
// import TrendOperation from '@/pages/trend-operation-new';
// import TrendOperationRedirect from '@/pages/trend-operation-new/redirect';
import ActivityMain from '@/pages/activity-main';
// 日常活动
import MyCreate from '@/pages/activity-manage/my-create';
import MyCreateChildren from '@/pages/activity-manage/my-create/route-config';
import userSettingRouteConfig from '@/pages/user-setting/route-config';
import IconHome from '@/components/icons/icon-home';
import IconActive from '@/components/icons/icon-active';
import IconDaily from '@/components/icons/icon-daily';
import IconChannel from '@/components/icons/icon-channel';
import IconPlantform from '@/components/icons/icon-plantform';
import IconMaterialManage from '@/components/icons/icon-material-manage';
import IconDataPanel from '@/components/icons/icon-data-panel';
import IconTrend from '@/components/icons/icon-trend';
import IconSystem from '@/components/icons/icon-system';
import IconTodo from '@/components/icons/icon-todo';
import IconProductManager from '@/components/icons/icon-product-manager';
import IconPh from '@/components/icons/icon-ph';
import IconPlatformMarketing from '@/components/icons/icon-platformMarketing';
// import IconFunctionMatrix from '@/components/icons/icon-function-matrix';
// import IconAdvertise from '@/components/icons/icon-advertise';
import ChannelMicro from './channel-micro';
import ChannelMicroRouteConfig from './channel-micro/route-config';

import Ph from '@/pages/ph';
import MicroApp from '@/components/micro-app';
import env from '@/env';
import TagManageList from '@/pages/activity-manage/tag-manage-list';

// 跨品类营销
import CrossCategoryMarketing from '@/pages/cross-category-marketing';
import CrossCategoryMarketingMenus from '@/pages/cross-category-marketing/route-config';

import TfMaterial from './tf-injected/material';
import TfLaunch from './tf-injected/launch';
import TfPandora from './tf-injected/pandora';
import TfNewPandora from './tf-injected/newpandora';
import TfInteraction from './tf-injected/interaction';
import TfWiki from './tf-injected/wiki';
import TfSwifthorse from './tf-injected/swifthorse';
import '@/micro-app/tb-open-area/utils';
import RouteConfigOfProductManager from './product-manager/route-config';
import Iframe from '@/components/iframe';
import YXTools from '@/pages/yxtools';
import GoldProcessExchangeMicroAppApplication from './activity-manage/merchants/detail/components/gold-process-exchange';
import DripworksInformationCenter from '@/micro-app/dripworks-information-center';
import Jinghailu from '@/pages/tf-injected/jinghailu';
import CtoB from '@/micro-app/CtoB';
import peachBlossomMenus from '@/pages/peach-blossom/route-config';
// import Resources from '@/pages/resources'
// import TrendOperationMenus from '@/pages/trend-operation-new/route-config';
// import Activity from '@/pages/activity'
// import ResourceManage from '@/pages/resource-manage'
// import resourceManageMenus from '@/pages/resource-manage/route-config'
// import checkList from '@/pages/activity-manage/check-list'
// import checkListChildren from '@/pages/activity-manage/check-list/route-config'
// import ActivityMangeGuide from '../activity-manage-guide/index.js'

/**
 * TODO:
 * menu: [] 空数组有实际意义，需要想下怎么解决
 * 表示主栏目有权限，但是子栏目全都没有权限
 */
/**
 * routeItem:
 * {
 *  menuId: bumber | string 栏目ID （没有栏目ID表示是前端栏目，不受后端菜单权限系统控制）
 *  path: string 栏目对应的前端路由
 *  component: ReactComponent 路由对应的组件
 *  menus: Array<routeItem> | null 子栏目
 *  hideInNav: boolean 是否不展示在导航中
 *  title: string 在导航中展示的名字
 *  dynamic: boolean 是否是动态加载
 * }
 */
let routes = [
  {
    menuId: 25,
    menuCode: '002',
    title: '工作台',
    path: '/',
    Icon: IconHome,
    component: OperatePlatform,
  },
  {
    menuId: 57,
    menuCode: '003',
    path: '/all-about-me',
    component: React.lazy(() => import('@/pages/all-about-me')),
    title: '待办事项',
    menus: null,
    dynamic: true,
    Icon: IconTodo,
  },
  {
    menuId: 91,
    path: '/product-manager',
    menus: RouteConfigOfProductManager,
    title: '货主阵地',
    Icon: IconProductManager,
  },
  {
    menuId: 11,
    menuCode: '005-1',
    title: '主题活动',
    businessId: 10003,
    path: '/activity-manage/list',
    Icon: IconActive,
    component: ActivityMain,
  },
  {
    menuId: 53,
    title: '日常活动',
    path: '/activity-manage/myCreate',
    Icon: IconDaily,
    component: MyCreate,
    menus: MyCreateChildren,
  },
  {
    title: '平台营销阵地',
    path: '/platform-marketing/fullGiftPool',
    component: GoldProcessExchangeMicroAppApplication,
  },
  {
    menuId: 65,
    menuCode: '005-4',
    title: '平台营销阵地',
    path: '/platform-marketing',
    Icon: IconPlatformMarketing,
    component: React.lazy(() => import('@/pages/platform-marketing-position')),
    dynamic: true,
  },
  {
    menuId: 35,
    menuCode: '005-5',
    title: '行业频道',
    path: '/channel-service',
    Icon: IconChannel,
    component: React.lazy(() => import('@/pages/channel-service')),
    dynamic: true,
  },
  {
    title: '平台资源',
    path: '/material-manage',
    Icon: IconPlantform,
    menus: materialManageRouteConfig,
  },
  {
    title: '资源管理',
    path: '/resource-manage',
    menus: materialManageRouteConfig,
    Icon: IconMaterialManage,
  },
  {
    menuId: 39,
    title: '素材管理',
    path: '/res-manage',
    Icon: IconMaterialManage,
    menus: resManageRouteConfig,
  },
  {
    menuId: 4,
    menuCode: '008',
    title: '数据中心',
    path: '/data-panel',
    Icon: IconDataPanel,
    component: React.lazy(() => import('datapanelInAcore/pages/data-panel')),
    menus: null,
    dynamic: true,
  },
  // {
  //   hideInNav: true,
  //   menuId: 46,
  //   path: '/trend-operation',
  //   title: '营销词阵地',
  //   Icon: IconTrend,
  //   component: TrendOperationRedirect,
  // },
  // {
  //   menuId: 46,
  //   path: '/trend-operation/*',
  //   title: '营销词阵地',
  //   Icon: IconTrend,
  //   component: TrendOperation,
  //   getCrumb(context) {
  //     const { extraCrumbs } = context.breadCrumbs;

  //     if (!extraCrumbs) return undefined;

  //     return extraCrumbs;
  //   },
  // },
  {
    menuId: 5,
    menuCode: '009',
    title: '系统设置',
    path: '/system',
    Icon: IconSystem,
    component: React.lazy(() => import('@/pages/system')),
    dynamic: true,
    menus: null,
  },
  {
    menuId: 10,
    title: '主题活动',
    path: '/activity-manage',
    component: React.lazy(() => import('@/pages/activity-manage')),
    menus: null,
    dynamic: true,
  },
  {
    title: '无权限',
    path: '/nopower',
    component: NoPower,
    hideInNav: true,
  },
  {
    title: '404',
    path: '/404',
    component: NotFound,
    hideInNav: true,
  },
  {
    title: '资源申请',
    path: '/resources-apply',
    component: ResourcesApply,
    hideInNav: true,
  },
  {
    // 提报用户设置
    title: '用户设置',
    path: '/user-setting',
    menus: userSettingRouteConfig,
    hideInNav: true,
  },
  {
    title: '组件',
    path: '/pkgs',
    component: Pkgs,
    menus: pkgsRouteConfig,
  },
  {
    path: '/ph/*',
    title: '收品工具',
    menuId: 56,
    Icon: IconPh,
    getLink({ path }) {
      return `${path}/phlist/manage`;
    },
    component: Ph,
  },
  {
    title: '批量建厂',
    path: '/batch-micro',
    component: () => {
      return <MicroApp name="batchMicro" url={`${env.ACE_DOMAIN}/pandora/`} />;
    },
  },
  {
    title: '微频道',
    path: '/channel-micro',
    component: ChannelMicro,
    menus: ChannelMicroRouteConfig,
  },

  /* ************* 跨品类营销 ***************** */
  {
    path: '/kpl',
    title: '跨品类营销',
    component: CrossCategoryMarketing,
    menus: CrossCategoryMarketingMenus,
    hideInNav: true,
  },
  /* *********** 经海路频道标签平台内嵌 ******** */
  {
    path: '/selection',
    title: '新潘多拉',
    component: TfNewPandora,
    hideInNav: true,
  },
  {
    path: '/tag-manage-list/*',
    title: '标签平台',
    component: TagManageList,
    menuCode: '007-7',
    menuId: 107,
    hideInNav: true,
  },
  {
    path: '/material/*',
    title: '素材管理',
    component: TfMaterial,
  },
  {
    path: '/material',
    title: '素材管理',
    component: TfMaterial,
  },
  {
    path: '/launch/*',
    title: '自动化运营',
    component: TfLaunch,
  },
  {
    path: '/launch',
    title: '自动化运营',
    component: TfLaunch,
  },
  {
    path: '/pandora/*',
    title: '自动化运营',
    component: TfPandora,
  },
  {
    path: '/pandora',
    title: '自动化运营',
    component: TfPandora,
  },
  {
    path: '/interaction/*',
    title: '互动工坊',
    component: TfInteraction,
  },
  {
    path: '/interaction',
    title: '互动工坊',
    component: TfInteraction,
  },
  {
    path: '/wiki/*',
    title: '知识库',
    component: TfWiki,
  },
  {
    path: '/wiki',
    title: '知识库',
    component: TfWiki,
  },
  {
    path: '/swifthorse/*',
    title: '赛马',
    component: TfSwifthorse,
  },
  {
    path: '/swifthorse',
    title: '赛马',
    component: TfSwifthorse,
  },
  {
    title: '用户运营',
    path: '/user-operate',
    menuCode: '006-1',
    menuId: 110,
    component: () => <MicroApp name="userOperate" url={env.USER_OPERATE} />,
  },
  {
    title: '用户运营',
    path: '/user-operate/*',
    menuCode: '006-1',
    menuId: 110,
    component: () => <MicroApp name="userOperate" url={env.USER_OPERATE} />,
  },
  {
    title: '用户增长',
    path: '/category-diy',
    menuCode: '006-2',
    menuId: 111,
    component() {
      return <Iframe src={env.CATEGORY_DIY_URL} />;
    },
  },
  {
    menuCode: '006-3',
    menuId: 115,
    title: '用户触达',
    path: '/reach-operations',
    component: () => <MicroApp name="reachOperations" url={env.USER_REACH} />,
  },
  {
    menuCode: '006-3',
    menuId: 115,
    title: '用户触达',
    path: '/reach-operations/*',
    component: () => <MicroApp name="reachOperations" url={env.USER_REACH} />,
  },
  {
    title: '桃花岛',
    menuCode: '006-4',
    path: '/peach-blossom',
    menus: peachBlossomMenus,
  },
  {
    title: '推荐运营',
    path: '/recommend-operate',
    menuId: 98,
    menuCode: '005-8',
    component: () => <MicroApp name="recommendOperate" url={env.RECOMMEND_OPERATE} />,
  },
  {
    title: '推荐运营',
    path: '/recommend-operate/*',
    menuId: 98,
    menuCode: '005-8',
    component: () => <MicroApp name="recommendOperate" url={env.RECOMMEND_OPERATE} />,
  },
  {
    title: '搜推运营',
    path: '/search-operate',
    menuId: 99,
    menuCode: '005-10',
    component: () => <Iframe src={env.SEARCH_OPERATE} />,
  },
  {
    title: '搜推运营',
    path: '/search-operate/*',
    menuId: 99,
    menuCode: '005-10',
    component: () => <Iframe src={env.SEARCH_OPERATE} />,
  },
  {
    title: '情报中心',
    path: '/information-center',
    menuId: 116,
    menuCode: '005-14',
    component: DripworksInformationCenter,
  },
  {
    title: '情报中心',
    path: '/information-center/*',
    menuId: 116,
    menuCode: '005-14',
    component: DripworksInformationCenter,
  },
  {
    title: '黄流运营',
    path: '/cargo-gold-operate/pool',
    menuId: 117,
    component: GoldProcessExchangeMicroAppApplication,
  },
  {
    title: '黄流运营',
    path: '/cargo-gold-operate',
    menuId: 117,
    component: () => <Iframe name="cargo-gold-operate1" src={env.GOLD_OPERATE} />,
  },
  {
    title: '黄流运营',
    path: '/cargo-gold-operate/*',
    menuId: 117,
    component: () => <Iframe name="cargo-gold-operate1" url={env.GOLD_OPERATE} />,
  },
  {
    menuCode: '005-13',
    menuId: 114,
    title: '搭售运营',
    path: '/in-operation',
    component: () => <Iframe src={env.DASHOU_YUNYING_URL} />,
  },
  {
    menuCode: '005-13',
    menuId: 114,
    title: '搭售运营',
    path: '/in-operation/*',
    component: () => <Iframe src={env.DASHOU_YUNYING_URL} />,
  },
  {
    title: '营销工具',
    path: '/yxtools',
    menuCode: '007-2',
    component: YXTools,
  },
  {
    title: '标签平台',
    path: '/jinghailu',
    component: Jinghailu,
  },
  {
    title: '标签平台',
    path: '/jinghailu/*',
    component: Jinghailu,
  },
  {
    title: '运营工作台',
    path: '/operations-workbench',
    menuId: 119,
    menuCode: '005-15',
    component: () => <CtoB name="operationsWorkbench" url={env.C2B_LINK} />,
  },
  {
    title: '运营工作台',
    path: '/operations-workbench/*',
    menuId: 119,
    menuCode: '005-15',
    component: () => <CtoB name="operationsWorkbench" url={env.C2B_LINK} />,
  },
];

export function updateRoutes(newRoutes) {
  routes = newRoutes;
}

export default routes;
